/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { HeadlineFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { HeadlineFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const productHeadlineDataMock: HeadlineFragmentFragment = {
  brand: {
    image: 'https://bilder.imwalking.de/marken/imwalkingde/nikesportswear.gif',
    name: 'Nike Sportswear',
  },
  name: 'Nike Sportswear Sneaker »Air Max Ltd 3«',
  orderNumber: '96692022',
  promotion: '79',
  productSeo: {
    brandLink: {
      url: '/brands/example',
    },
  },
};

export function getProductHeadlineFragmentedData(data?: HeadlineFragmentFragment) {
  return makeFragmentData(data || productHeadlineDataMock, HeadlineFragmentFragmentDoc);
}
